import { X } from "lucide-react";
import { Label } from "./shared";

export function ReceiptCancelModal({ busy, cancelReason, cancelling, confirmCancel, items, setCancelReason, setCancelling }) {
  return (
    <>
      {cancelling && (
        <div className="fixed inset-0 bg-black/60 z-50 grid place-items-center p-4">
          <div className="bg-white rounded-md w-full max-w-md p-6">
            <div className="flex items-start justify-between gap-4 mb-3">
              <div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-rose-700">
                  Cancelar recibo
                </div>
                <h3 className="mt-1 font-serif-display text-xl">
                  {cancelling.number}
                </h3>
                <p className="text-xs text-slate-500 mt-0.5">
                  Beneficiário: {cancelling.payer_name}
                </p>
              </div>
              <button
                onClick={() => {
                  setCancelling(null);
                  setCancelReason("");
                }}
                className="text-slate-500 hover:text-slate-900"
              >
                <X size={20} />
              </button>
            </div>
            <p className="text-sm text-slate-700">
              Esta ação não pode ser desfeita. O destinatário será notificado
              automaticamente do cancelamento por e-mail.
            </p>
            <div className="mt-4">
              <Label>Motivo do cancelamento *</Label>
              <textarea
                data-testid="cancel-reason"
                required
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                className="mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm min-h-[90px]"
                placeholder="Ex.: Recibo emitido em duplicidade, valor incorreto, etc."
              />
            </div>
            <div className="mt-6 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => {
                  setCancelling(null);
                  setCancelReason("");
                }}
                className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
              >
                Voltar
              </button>
              <button
                data-testid="cancel-confirm"
                onClick={confirmCancel}
                disabled={busy}
                className="px-5 py-2 bg-rose-700 text-white text-[11px] uppercase tracking-[0.22em] hover:bg-rose-800 disabled:opacity-60"
              >
                {busy ? "Cancelando..." : "Confirmar cancelamento"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
